<ion-card [ngClass]="{'no-box-shadow': !borderShadow}">
  <ion-card-content>
    <ion-row>
      <ion-col>
        <aaa-text color="tertiary" display="block" size="subheadline" weight="bold" class="destination-name">
          {{ title }}
        </aaa-text>
        <aaa-text weight="semibold" class="distance-status">
          <p>
            <aaa-text size="footnote" display="inline" color="subtle">
              <app-distance-display [distance]="distance" [short]="true"></app-distance-display>
            </aaa-text>
            <app-facility-status-variant [status]="status" [operatingDays]="operatingDays" class="facility-status"></app-facility-status-variant>
            @if (operatingDays) {
              <aaa-text size="caption2" display="inline" color="faint" weight="regular">
                <app-facility-next-date class="facility-next-date" [operatingDays]="operatingDays"></app-facility-next-date>
              </aaa-text>
            }
          </p>
        </aaa-text>
      </ion-col>

      <ion-col size="auto" *ngIf="suggested">
        <drr-facility-badge variation="card" [markerDetails]="{ badge: 'Suggested', active: true }"></drr-facility-badge>
      </ion-col>
    </ion-row>

    <ng-content select="[content]"></ng-content>

    <ng-content select="[footer]"></ng-content>
  </ion-card-content>
</ion-card>
